<div class="right-margin">
    <button class="close-icon" (click)="dialogRef.close(false)"><div class="line1"><div class="line2"></div></div></button>
</div>
<div class="body form">
    <h2>{{confirmTitle}}</h2>
    <div class="info">{{confirmMessage}}</div>
    <div class="block-buttons mt-20 text-center">
        <button type="button" (click)="dialogRef.close(false)">{{cancelButton}}</button>
        <button type="button" (click)="dialogRef.close(true)">{{confirmButton}}</button>
    </div>
</div>